import React from 'react';

export const facebookIcon = ({ ariaLabel = 'Facebook' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}>
      <path d="M8.61113 7.22224V8.33337H7.5V10H8.61113V15H10.8333V10H12.3111L12.5 8.33337H10.8333V7.36113C10.8333 6.91115 10.8778 6.67224 11.5722 6.67224H12.5V5H11.0111C9.23336 5.00005 8.61113 5.83335 8.61113 7.22224Z" fill="#FDF8ED" />
      <path d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 19.0909C4.97922 19.0909 0.909102 15.0208 0.909102 10C0.909102 4.97922 4.97922 0.909102 10 0.909102C15.0208 0.909102 19.0909 4.97922 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909Z" fill="#FDF8ED" />
    </svg>
  );
};
